import styled from 'styled-components';
import { Icon as LegacyIcon } from '@ant-design/compatible';

export const StyledPasswordHelperDiv = styled.div`
  text-align: center;
`;

export const StyledPasswordHelperBlockDiv = styled.div`
  display: inline-block;
  text-align: left;
`;

export const StyledLegacyIcon = styled(LegacyIcon)<{
  $isValid?: boolean;
}>`
  color: ${({ $isValid }) => ($isValid ? 'var(--good)' : 'var(--bad)')};
`;
